import {
    GLOBAL_CONTENT_LOADED,
    PAGE_CONTENT_LOADED,
    SELECT_GENDER,
    CONTENT_ROUTE,
    SCREEN_RESIZE,
    SCREEN_BREAKPOINT,
    SET_PREVIEW_TOKEN,
    FLICKITY_DRAG_END,
    LOAD_MORE_ARTICLES_SUCCESSFUL
} from '../actions'
import {NOT_FOUND} from 'redux-first-router'
import get from 'lodash/get'
import {canUseDom} from "../utils/dom"
import {genderEmpty} from "../utils/gender"
import theme from '../styles/theme'

const initialState = {
    global: undefined,
    page: undefined,
    loadingMore: false,
    articles: [],
    gender: genderEmpty,
    screenWidth: canUseDom ? window.innerWidth : null,
    breakpoint: theme.breakpoints.desktop,
    previewToken: null
}

const content = (state = initialState, action) => {
    switch (action.type) {
        case CONTENT_ROUTE:
            const gender = get(action, ['query', 'g']);
            if(!gender) return state;
            return {
                ...state,
                gender: gender
            };
        case GLOBAL_CONTENT_LOADED:
            return {
                ...state,
                global: action.payload.globalContent
            }
        case PAGE_CONTENT_LOADED:
            return {
                ...state,
                page: action.payload.content,
            }
        case NOT_FOUND:
            return {
                ...state,
                page: { type: "not-found" }
            }
        case SELECT_GENDER:
            return {
                ...state,
                gender: action.payload.gender
            }
        case SCREEN_RESIZE:
            return {
                ...state,
                screenWidth: action.screenWidth
            }
        case SCREEN_BREAKPOINT:
            return {
                ...state,
                breakpoint: action.breakpoint
            }
        case SET_PREVIEW_TOKEN:
            return {
                ...state,
                previewToken: action.payload
            }
        case FLICKITY_DRAG_END:
            return {
                ...state,
                flickityDragEndTime: action.payload.time
            }
        case LOAD_MORE_ARTICLES_SUCCESSFUL:
            if(!action.payload.content.landing_page_uid ||
                state.page.landing_page_uid !== action.payload.content.landing_page_uid)
                return state;

            return {
                ...state,
                page: {
                    ...state.page,
                    slices: [
                        ...state.page.slices,
                        ...action.payload.content.slices
                    ]
                }
            };

        default:
            return state
    }
}

export default content



// WEBPACK FOOTER //
// ./src/reducers/content.js